import styled from 'styled-components';

export const FormGroup = styled.div`
  align-items: flex-start;
  display: grid;
  gap: 4px;
`;
